import { render, staticRenderFns } from "./JourneyConnectionGeneralSettings.vue?vue&type=template&id=1af40109&scoped=true&"
import script from "./JourneyConnectionGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionGeneralSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af40109",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af40109')) {
      api.createRecord('1af40109', component.options)
    } else {
      api.reload('1af40109', component.options)
    }
    module.hot.accept("./JourneyConnectionGeneralSettings.vue?vue&type=template&id=1af40109&scoped=true&", function () {
      api.rerender('1af40109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/JourneyConnectionGeneralSettings.vue"
export default component.exports